import { SidenavMenu } from './sidenav-menu.model';

export const sidenavMenuItems = [
    new SidenavMenu (9991, 'romelux.label.HomePage.HomePage', '/', null, null, false, 0),
    new SidenavMenu (9992, 'romelux.label.HomePage.AllProducts', '/products', null, null, false, 0),
    new SidenavMenu (9999, 'romelux.label.HomePage.Categories', '/categories', null, null, true, 0),
    new SidenavMenu (9993, 'romelux.label.HomePage.MyCart', '/cart', null, null, false, 0),
    new SidenavMenu (9994, 'romelux.label.HomePage.Contact', '/contact', null, null, false, 0),


]
